import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { useMsal } from '@azure/msal-react';
import { TokenHelper } from '../../TokenHelper';
import { useTranslation } from 'react-i18next';
import { dataActionCreators } from '../../store/Data';
import { DownloadIcon, useEditorStyles, ViewIcon } from '../Styles/Editor';
import { Body1Stronger, Button, Caption1, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Divider, Dropdown, Field, Input, InputOnChangeData, Link, MessageBar, MessageBarBody, MessageBarTitle, Option, SelectionEvents, Spinner, Subtitle1, Switch, SwitchOnChangeData, Text, Textarea, TextareaOnChangeData, Toast, ToastBody, ToastTitle, ToastTrigger, tokens, Tooltip, useToastController } from '@fluentui/react-components';
import { FileViewer } from '../FileViewer/FileViewer';
import { DownloadFile } from '../Tools/FileDownloadHelper';
import { ConsultantPeppolReceivedInvoice, ConsultantPeppolReceivedCreditNote, ConsultantPeppolReceivedDoc } from '../../interfaces/Consultant';
import generateQrText from 'sepa-payment-qr-code';
import QRCode from 'qrcode';
import { isValidStructuredCommunication } from '../Tools/Validator';
import saveAs from "file-saver";
import * as i18n from "i18next";
import { DatePicker } from '@fluentui/react-datepicker-compat';
import { onFormatDate } from '../Tools/converters';
import { ConvertionHelpers } from '../../ConvertionHelpers';
import { ConsultantActionCreators } from '../../store/consultants';
import { AnalysePeppolXML } from '../../Peppol/Peppol';
import { DecodeDoc } from '../../Peppol/PeppolInterfaces';
import { getVATTypeSelectionString } from '../EditorHelpers/VATDropdown';
export function getPeppolStatusString(dt: number | null): string {
    if (dt === null) {
        return i18n.t('0', { ns: 'PeppolStatus' });
    }
    switch (dt) {
        case 0:
            return i18n.t('0', { ns: 'PeppolStatus' });
        case 1:
            return i18n.t('1', { ns: 'PeppolStatus' });
        case 2:
            return i18n.t('2', { ns: 'PeppolStatus' });
        case 3:
            return i18n.t('3', { ns: 'PeppolStatus' });
    }
    return i18n.t('0', { ns: 'PeppolStatus' });
}

export function getUnitCodeString(uc?: string | null): string {
    if (uc) {
        switch (uc) {
            case "DAY":
            case "HUR":
            case "MON":
            case "1I":
            case "C62":
            case "XPK":
                return i18n.t(uc, { ns: 'PeppolUnitCode' });
        }
    }
    return i18n.t("Default", { ns: 'PeppolUnitCode' });
}

type PeppolStatusDropdownProps = {
    setPeppolStatus: (dt: number) => void;
    currentStatus: number | null;
};

export const PeppolStatusDropdown: React.FC<PeppolStatusDropdownProps> = ({ setPeppolStatus, currentStatus }) => {
    const styles = useEditorStyles();
    const { t } = useTranslation();

    return <Dropdown
        positioning="below"
        listbox={{
            className: styles.optionContainer,
        }}
        placeholder={t('SelectDocumentType')}
        className={styles.fluid}
        onOptionSelect={(event: SelectionEvents, data: { optionValue: string | undefined; }) => {
            setPeppolStatus(data.optionValue === undefined ? 21 : parseInt(data.optionValue));
        }}
        value={getPeppolStatusString(currentStatus)}
        selectedOptions={currentStatus ? [currentStatus.toString()] : []}
    >
        <Option key="0" value="0">{i18n.t('0', { ns: 'PeppolStatus' })}</Option>
        <Option key="1" value="1">{i18n.t('1', { ns: 'PeppolStatus' })}</Option>
        <Option key="2" value="2">{i18n.t('2', { ns: 'PeppolStatus' })}</Option>
        <Option key="3" value="3">{i18n.t('3', { ns: 'PeppolStatus' })}</Option>
    </Dropdown>;
};


interface NewPeppolStatus {
    lock?: boolean,
    accountingRef?: string | null,
    description?: string | null,
    status?: number | null,
    paymentDate?: string | null,
}


export const PeppolReceivedDocs = () => {
    // All data needed for edition should be loaded before calling the editor
    const peppolReceivedDocEdit = useSelector((state: ApplicationState) => state.data.peppolReceivedDocEdit);
    const teamsState = useSelector((state: ApplicationState) => state.teamsState);
    const UserLoginState = useSelector((state: ApplicationState) => state.userNeomyticLogin);
    // Gen hooks
    const dispatch = useDispatch();
    const { instance } = useMsal();
    const { t } = useTranslation();
    const styles = useEditorStyles();
    const { dispatchToast, updateToast } = useToastController("NeoToasterUnique");
    //const tabStyles = useTabStyles();
    // const
    const IsInvoice = React.useMemo(() => {
        return peppolReceivedDocEdit && "peppolReceivedInvoiceId" in peppolReceivedDocEdit && typeof (peppolReceivedDocEdit as any).peppolReceivedInvoiceId === "string";
    }, [peppolReceivedDocEdit]);
    const IsCreditNote = React.useMemo(() => {
        return peppolReceivedDocEdit && "peppolReceivedCreditNoteId" in peppolReceivedDocEdit && typeof (peppolReceivedDocEdit as any).peppolReceivedCreditNoteId === "string";
    }, [peppolReceivedDocEdit]);
    const [decodeDoc, setDecodeDoc] = React.useState<DecodeDoc | null>(null);
    // Fields
    //const [c, setC] = React.useState<Customer | null>(null);
    const [paymentDate, setPaymentDate] = React.useState<Date | null>(peppolReceivedDocEdit && "peppolReceivedInvoiceId" in peppolReceivedDocEdit && typeof (peppolReceivedDocEdit as any).peppolReceivedInvoiceId === "string" && (peppolReceivedDocEdit as any).paymentDate ? new Date((peppolReceivedDocEdit as any).paymentDate) : null);
    const [peppolStatus, setPeppolStatus] = React.useState<number | null>(peppolReceivedDocEdit && "peppolReceivedInvoiceId" in peppolReceivedDocEdit && typeof (peppolReceivedDocEdit as any).peppolReceivedInvoiceId === "string" ? (peppolReceivedDocEdit as any).status : null);
    const [description, setDescription] = React.useState<string | null>(peppolReceivedDocEdit ? peppolReceivedDocEdit.description : "");
    const [accountingRef, setAccountingRef] = React.useState<string | null>(peppolReceivedDocEdit ? peppolReceivedDocEdit.accountingRef : "");
    const [lock, setLock] = React.useState<boolean>(peppolReceivedDocEdit ? peppolReceivedDocEdit.lock : false);
    // Form validation
    const [file, setFile] = React.useState<Blob>();
    //const [xml, setXml] = React.useState<string>();
    const [SEPAQRCode, setSEPAQRCode] = React.useState<string>();
    const [filePreview, setFilePreview] = React.useState<Blob>();

    const validChange = React.useMemo(() => {
        const currentStatus = IsInvoice ? ((peppolReceivedDocEdit as ConsultantPeppolReceivedInvoice).status ?? 0) : 0;
        const newStatus = peppolStatus ?? 0;
        const currentDescription = peppolReceivedDocEdit ? (peppolReceivedDocEdit.description ?? "") : "";
        const currentAccountingRef = peppolReceivedDocEdit ? (peppolReceivedDocEdit.accountingRef ?? "") : "";
        const currentLock = peppolReceivedDocEdit ? peppolReceivedDocEdit.lock : false;
        if (IsInvoice && currentStatus !== newStatus) {
            return true;
        }
        if ((description ?? "") !== currentDescription
            || (accountingRef ?? "") !== currentAccountingRef
            || lock !== currentLock
        ) {
            return true;
        }
        return false;
    }, [peppolReceivedDocEdit, IsInvoice, peppolStatus, description, accountingRef, lock]);

    React.useEffect(() => {
        TokenHelper.GetToken(instance, teamsState)
            .then(token => {
                if (token !== null) {
                    if (peppolReceivedDocEdit && IsInvoice) {
                        DownloadFile('api/PeppolReceivedInvoices/' + (peppolReceivedDocEdit as ConsultantPeppolReceivedInvoice).peppolReceivedInvoiceId + "/UBL", token)
                            .then((f) => {
                                if (f) {
                                    setFile(f);
                                    f.text().then((s) => {
                                        //setXml(s);
                                        const decodeDoc = AnalysePeppolXML(s);
                                        //console.log(decodeDoc);
                                        setDecodeDoc(decodeDoc);

                                        if (IsInvoice && decodeDoc.iban && decodeDoc.payable && decodeDoc.payable.amount !== 0) {
                                            const epc: any = {
                                                name: decodeDoc.supplierName,
                                                iban: decodeDoc.iban,
                                                amount: decodeDoc.payable.amount,                  // EUR only
                                                information: 'Sample QR code'
                                            };
                                            if (decodeDoc.communication && decodeDoc.communication.length > 0) {
                                                if (isValidStructuredCommunication(decodeDoc.communication)) {
                                                    epc.structuredReference = decodeDoc.communication;
                                                }
                                                else {
                                                    epc.unstructuredReference = decodeDoc.communication;
                                                }
                                            }
                                            const epcText = generateQrText(epc);
                                            QRCode.toString(epcText, { type: 'svg', errorCorrectionLevel: 'M' })
                                                .then((svgString: string) => {
                                                    setSEPAQRCode(svgString);
                                                    //    console.log(svgString); // raw SVG markup
                                                })
                                                .catch((err: any) => console.error(err));
                                        }
                                    });
                                }
                            })
                            .catch((e) => { console.log(e); });
                    }
                    if (peppolReceivedDocEdit && IsCreditNote) {
                        DownloadFile('api/PeppolReceivedCreditNotes/' + (peppolReceivedDocEdit as ConsultantPeppolReceivedCreditNote).peppolReceivedCreditNoteId + "/UBL", token)
                            .then((f) => {
                                if (f) {
                                    setFile(f);
                                    f.text().then((s) => {
                                        //setXml(s);
                                        const decodeDoc = AnalysePeppolXML(s);
                                        setDecodeDoc(decodeDoc);
                                    });
                                }
                            })
                            .catch((e) => { console.log(e); });
                    }
                }
            });
    }, [peppolReceivedDocEdit]);

    const submit = () => {
        const c: NewPeppolStatus = {
            description: description,
            accountingRef: accountingRef,
            lock: lock,
            paymentDate: ConvertionHelpers.DateToISODateOnly(paymentDate) ?? null,
            status: peppolStatus ?? 0
        };
        let objId = "";
        if (IsInvoice) {
            objId = (peppolReceivedDocEdit as ConsultantPeppolReceivedInvoice).peppolReceivedInvoiceId;
        }
        else {
            objId = (peppolReceivedDocEdit as ConsultantPeppolReceivedCreditNote).peppolReceivedCreditNoteId;
        }

        TokenHelper.GetToken(instance, teamsState)
            .then(token => {
                if (token !== null) {
                    const toastId = (Math.random() + 1).toString(36).substring(7);
                    dispatchToast(
                        <Toast appearance="inverted">
                            <ToastTitle>
                                {i18n.t('SavingStatus', { ns: "Toasts" })}
                            </ToastTitle>
                            <ToastBody>
                                <div className={styles.Vertical}>
                                    <Text>{t(IsInvoice ? 'PeppolInvoiceFrom' : 'PeppolCreditNoteFrom', { supplier: peppolReceivedDocEdit?.registrationName ?? "-" })}</Text>
                                </div>
                            </ToastBody>
                        </Toast>,
                        { intent: "info", timeout: -1, position: "top-end", toastId: toastId }
                    );
                    fetch("api/" + (IsInvoice ? "PeppolReceivedInvoices" : "PeppolReceivedCreditNotes") + "/" + objId, {
                        method: "PUT",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: "bearer " + token,
                        },
                        body: JSON.stringify(c),
                        mode: "cors",
                        cache: "default",
                    })
                        .then(response => {
                            if (response.status === 200) {
                                updateToast({
                                    content: (
                                        <Toast appearance="inverted">
                                            <ToastTitle action={
                                                <ToastTrigger>
                                                    <Link>{i18n.t('Dismiss', { ns: "Toasts" })}</Link>
                                                </ToastTrigger>
                                            }>
                                                {i18n.t('SavingStatusSucceed', { ns: "Toasts" })}
                                            </ToastTitle>
                                            <ToastBody>
                                                <div className={styles.Vertical}>
                                                    <Text>{t(IsInvoice ? 'PeppolInvoiceFrom' : 'PeppolCreditNoteFrom', { supplier: peppolReceivedDocEdit?.registrationName ?? "-" })}</Text>
                                                </div>
                                            </ToastBody>
                                        </Toast>
                                    ),
                                    intent: "success",
                                    toastId,
                                    timeout: 5000,
                                    pauseOnHover: true,
                                });
                                return response.json() as Promise<ConsultantPeppolReceivedDoc>;
                            }
                            else {
                                updateToast({
                                    content: (
                                        <Toast appearance="inverted">
                                            <ToastTitle action={
                                                <ToastTrigger>
                                                    <Link>{i18n.t('Dismiss', { ns: "Toasts" })}</Link>
                                                </ToastTrigger>
                                            }>
                                                {i18n.t('SavingStatusFailed', { ns: "Toasts" })}
                                            </ToastTitle>
                                            <ToastBody>
                                                <div className={styles.Vertical}>
                                                    <Text>{t(IsInvoice ? 'PeppolInvoiceFrom' : 'PeppolCreditNoteFrom', { supplier: peppolReceivedDocEdit?.registrationName ?? "-" })}</Text>
                                                </div>
                                            </ToastBody>
                                        </Toast>
                                    ),
                                    intent: "error",
                                    toastId,
                                    timeout: 10000,
                                    pauseOnHover: true,
                                });
                            }
                        })
                        .then(data => {
                            if (data) {
                                if (IsInvoice) {
                                    dispatch(ConsultantActionCreators.patchConsultantPeppolReceivedInvoices(data as ConsultantPeppolReceivedInvoice));
                                }
                                else if (IsCreditNote) {
                                    dispatch(ConsultantActionCreators.patchConsultantPeppolReceivedCreditNotes(data as ConsultantPeppolReceivedCreditNote));
                                }
                                dispatch(dataActionCreators.editReceivedPeppolDoc(null));
                            }
                        });
                }
            });

    };

    if (!peppolReceivedDocEdit || decodeDoc === null) {
        return <Dialog
            open
            modalType="modal">
            <DialogSurface>
                <DialogBody>
                    <DialogContent>
                        <Spinner />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                dispatch(dataActionCreators.editReceivedPeppolDoc(null));
                            }}
                        >
                            {t("Cancel")}
                        </Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface >
        </Dialog >;
    }

    return <Dialog
        open
        modalType="modal">
        <DialogSurface className={filePreview ? styles.DialogContentWithFilePreview : undefined}>
            <DialogBody className={styles.fluid}>
                <DialogTitle>{t(IsInvoice ? 'PeppolInvoiceFrom' : 'PeppolCreditNoteFrom', {
                    supplier: peppolReceivedDocEdit.registrationName, interpolation: { escapeValue: false }
                })}</DialogTitle>
                <DialogContent>
                    <div className={styles.onSingleLinWithFilePreviewe}>
                        {filePreview &&
                            <FileViewer file={filePreview} />
                        }
                        <div className={filePreview ? styles.InfoPart : styles.fluid} style={{
                            display: "flex", flexDirection: "column", gap: tokens.spacingVerticalM
                        }}
                        >
                            {decodeDoc === null
                                ?
                                <Spinner />
                                :
                                <>
                                    {peppolReceivedDocEdit.isTestDoc &&
                                        <MessageBar intent="error">
                                            <MessageBarBody>
                                                <MessageBarTitle>Peppol Test Document !!!</MessageBarTitle>
                                            </MessageBarBody>
                                        </MessageBar>
                                    }
                                    <div className={styles.ContentBoxBrandBackground}>
                                        {decodeDoc.supplierName &&
                                            <>
                                                <Subtitle1>{decodeDoc.supplierName}</Subtitle1>
                                            </>
                                        }
                                        <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "8px", alignItems: "flex-start" }}>
                                            <div className={styles.ContentBoxBrandBackgroundGrid} style={{ flexGrow: "1" }}>
                                                {decodeDoc.ID &&
                                                    <><Caption1>{t(IsInvoice ? 'Invoice' : 'CreditNote')}</Caption1><Body1Stronger>{decodeDoc.ID}</Body1Stronger></>
                                                }
                                                {decodeDoc.issueDate &&
                                                    <><Caption1>{t('IssueDate')}</Caption1><Body1Stronger>{decodeDoc.issueDate.toLocaleDateString()}</Body1Stronger></>
                                                }
                                                {decodeDoc.dueDate &&
                                                    <><Caption1>{t('DueDate')}</Caption1><Body1Stronger>{decodeDoc.dueDate.toLocaleDateString()}</Body1Stronger></>
                                                }
                                            {/*    {decodeDoc.taxExclusive &&*/}
                                            {/*        <><Caption1>Total HTVA</Caption1><Body1Stronger>{decodeDoc.taxExclusive.amount.toLocaleString(undefined, { style: 'currency', currency: decodeDoc.taxExclusive.currency })}</Body1Stronger></>*/}
                                            {/*    }*/}
                                            {/*    {decodeDoc.taxSubtotals.length === 0*/}
                                            {/*        ?*/}
                                            {/*        (decodeDoc.taxAmount &&*/}
                                            {/*            <><Caption1>Total TVA</Caption1><Body1Stronger>{decodeDoc.taxAmount.amount.toLocaleString(undefined, { style: 'currency', currency: decodeDoc.taxAmount.currency })}</Body1Stronger></>)*/}
                                            {/*        :*/}
                                            {/*        decodeDoc.taxSubtotals.map((tst) => {*/}
                                            {/*            let title = "Total TVA";*/}
                                            {/*            if (tst.percent) {*/}
                                            {/*                title = title + " " + tst.percent + "%";*/}
                                            {/*            }*/}
                                            {/*            let taxAmout = "?";*/}
                                            {/*            if (tst.taxAmount) {*/}
                                            {/*                taxAmout = tst.taxAmount.amount.toLocaleString(undefined, { style: 'currency', currency: tst.taxAmount.currency });*/}
                                            {/*            }*/}
                                            {/*            return <><Caption1>{title}</Caption1><Body1Stronger>{taxAmout}</Body1Stronger></>;*/}
                                            {/*        })*/}
                                            {/*    }*/}
                                            {/*    {decodeDoc.taxInclusive &&*/}
                                            {/*        <><div></div><Divider />*/}
                                            {/*            <Caption1>Total TVAC</Caption1><Body1Stronger>{decodeDoc.taxInclusive.amount.toLocaleString(undefined, { style: 'currency', currency: decodeDoc.taxInclusive.currency })}</Body1Stronger></>*/}
                                            {/*    }*/}
                                            </div>
                                            <div style={{ display: "flex", gap: tokens.spacingHorizontalS }}>
                                                <Tooltip content={t('SaveDocument')} relationship="label">
                                                    <Button
                                                        icon={<DownloadIcon />}
                                                        shape="circular"
                                                        aria-label="Download"
                                                        disabled={!file || !decodeDoc.supplierName}
                                                        onClick={() => {
                                                            if (decodeDoc.supplierName && file) {
                                                                saveAs(file, decodeDoc.supplierName);
                                                            }
                                                        }
                                                        } />
                                                </Tooltip>
                                                <Tooltip content={t('ViewDocument')} relationship="label">
                                                    <Button
                                                        icon={<ViewIcon />}
                                                        shape="circular"
                                                        aria-label="View"
                                                        disabled={!file}
                                                        onClick={() => {
                                                            if (file) {
                                                                if (filePreview !== file) {
                                                                    setFilePreview(file);
                                                                }
                                                                else {
                                                                    setFilePreview(undefined);
                                                                }
                                                            }
                                                        }
                                                        } />
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={styles.ContentBoxBrandBackground}>
                                        <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "8px", alignItems: "flex-start" }}>
                                            <div className={styles.ContentBoxBrandBackgroundGridInvoiceTotal} style={{ flexGrow: "1" }}>
                                                <Caption1>{t('PercentageVAT')}</Caption1><Caption1>{t('TotalExcludVAT')}</Caption1>
                                                <Caption1>{t('TotalVAT')}</Caption1><Caption1>{t('TotalIncludVAT')}</Caption1>
                                                {decodeDoc.taxSubtotals.map((tst) => {
                                                    let taxableAmount = "?";
                                                    //let currency = "EUR";
                                                    if (tst.taxableAmount !== undefined) {
                                                        //currency = tst.taxableAmount.currency;
                                                        taxableAmount = tst.taxableAmount.amount.toLocaleString(undefined, { style: 'currency', currency: tst.taxableAmount.currency });
                                                    }
                                                    let taxAmout = "?";
                                                    if (tst.taxAmount !== undefined) {
                                                        taxAmout = tst.taxAmount.amount.toLocaleString(undefined, { style: 'currency', currency: tst.taxAmount.currency });
                                                    }
                                                    let total = "?";
                                                    if (tst.taxableAmount !== undefined && tst.taxAmount !== undefined) {
                                                        total = (tst.taxableAmount.amount + tst.taxAmount.amount).toLocaleString(undefined, { style: 'currency', currency: tst.taxAmount.currency });
                                                    }
                                                    return <>
                                                        <Body1Stronger>{tst.percent !== undefined ? getVATTypeSelectionString(tst.percent) : "?"}</Body1Stronger>
                                                        <Body1Stronger>{taxableAmount}</Body1Stronger>
                                                        <Body1Stronger>{taxAmout}</Body1Stronger>
                                                        <Body1Stronger>{total}</Body1Stronger>
                                                    </>;
                                                })
                                                }
                                                <Divider /><Divider /><Divider /><Divider />
                                                <Caption1>Total</Caption1>
                                                <Body1Stronger>{decodeDoc.taxExclusive !== undefined ? decodeDoc.taxExclusive.amount.toLocaleString(undefined, { style: 'currency', currency: decodeDoc.taxExclusive.currency }) : "?"}</Body1Stronger>
                                                <Body1Stronger>{decodeDoc.taxAmount !== undefined ? decodeDoc.taxAmount.amount.toLocaleString(undefined, { style: 'currency', currency: decodeDoc.taxAmount.currency }) : "?"}</Body1Stronger>
                                                <Subtitle1>{decodeDoc.taxInclusive !== undefined ? decodeDoc.taxInclusive.amount.toLocaleString(undefined, { style: 'currency', currency: decodeDoc.taxInclusive.currency }) : "?"}</Subtitle1>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={styles.ContentBoxBrandBackground}>
                                        <Subtitle1>Comptable</Subtitle1>
                                        {IsInvoice &&
                                            <div className={styles.onSingleLine}>
                                                <Field label={<Caption1>Status</Caption1>} style={{ flexGrow: "1" }}>
                                                    <PeppolStatusDropdown
                                                        currentStatus={peppolStatus}
                                                        setPeppolStatus={(n) => {
                                                            setPeppolStatus(n);
                                                            if (n !== 2) {
                                                                setPaymentDate(null);
                                                            }
                                                        }}
                                                    />
                                                </Field>
                                                <Field label={<Caption1>{t('PaymentDate')}</Caption1>}>
                                                    <DatePicker className={styles.fluid}
                                                        onSelectDate={(date: Date | null | undefined) => {
                                                            const d = date === undefined ? null : date;
                                                            setPaymentDate(date === undefined ? null : date);
                                                            if (d !== null) {
                                                                setPeppolStatus(2);
                                                            }
                                                        }}
                                                        value={paymentDate === null ? undefined : paymentDate}
                                                        formatDate={onFormatDate}
                                                        placeholder={t('SelectPaymentDate')}
                                                        disabled={decodeDoc.payable && decodeDoc.payable.amount === 0}
                                                    />
                                                </Field>
                                            </div>
                                        }

                                        <Field label={<Caption1>{t('Remark')}</Caption1>}>
                                            <Textarea
                                                className={styles.fluid}
                                                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>, data: TextareaOnChangeData) => setDescription(data.value)}
                                                value={description !== null ? description : ""}
                                                resize="vertical"
                                            />
                                        </Field>
                                        {UserLoginState && UserLoginState.rigths && (UserLoginState.rigths.isAdmin || UserLoginState.rigths.canManageConsultantDocuments) && <>
                                            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "8px", alignItems: "flex-end" }}>
                                                <Field label={<Caption1>{t('AccountingRef')}</Caption1>} style={{ flexGrow: "1" }}>
                                                    <Input
                                                        autoComplete="off"
                                                        className={styles.fluid}
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => setAccountingRef(data.value)}
                                                        value={accountingRef !== null ? accountingRef : ""}
                                                    />
                                                </Field>
                                                <Switch label="is Locked"
                                                    checked={lock}
                                                    onChange={(ev: React.ChangeEvent<HTMLInputElement>, data: SwitchOnChangeData) => { setLock(data.checked); }} />
                                            </div>
                                        </>}
                                    </div>

                                    {IsInvoice &&
                                        <div className={styles.ContentBoxBrandBackground}>
                                            <Subtitle1>{t('PaymentDetails')}</Subtitle1>
                                            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "8px", alignItems: "flex-start" }}>
                                                <div className={styles.ContentBoxBrandBackgroundGrid} style={{ flexGrow: "1" }} >
                                                    {decodeDoc.payable &&
                                                        <><Caption1>{t('AmountToPay')}</Caption1><Body1Stronger>{decodeDoc.payable.amount.toLocaleString(undefined, { style: 'currency', currency: decodeDoc.payable.currency })}</Body1Stronger></>
                                                    }
                                                    {decodeDoc.accountName &&
                                                        <><Caption1>{t('AccountName')}</Caption1><Body1Stronger>{decodeDoc.accountName}</Body1Stronger></>
                                                    }
                                                    {decodeDoc.iban &&
                                                        <><Caption1>IBAN</Caption1><Body1Stronger>{decodeDoc.iban}</Body1Stronger></>
                                                    }
                                                    {decodeDoc.bic &&
                                                        <><Caption1>BIC</Caption1><Body1Stronger>{decodeDoc.bic}</Body1Stronger></>
                                                    }
                                                    {decodeDoc.communication &&
                                                        <><Caption1>Communication</Caption1><Body1Stronger>{decodeDoc.communication}</Body1Stronger></>
                                                    }
                                                </div>
                                                {SEPAQRCode &&
                                                    <div style={{ height: "150px", width: "150px", minHeight: "120px", minWidth: "120px" }}
                                                        dangerouslySetInnerHTML={{ __html: SEPAQRCode }}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    }
                                    {decodeDoc.lines.length > 0 &&
                                        <div className={styles.ContentBoxBrandBackground}>
                                            <Subtitle1>{t('Details')}</Subtitle1>
                                            <div className={styles.ContentBoxBrandBackgroundGrid2} style={{ flexGrow: "1" }}>
                                                {decodeDoc.lines.map((f, index) =>
                                                    <>
                                                        <Body1Stronger className={0 !== index ? styles.ContentBoxBrandBackgroundGrid2Item : styles.ContentBoxBrandBackgroundGrid2ItemNoLine} key={"Cap" + f.ID}>{f.name}</Body1Stronger>
                                                        <div className={0 !== index ? styles.ContentBoxBrandBackgroundGrid2Item : styles.ContentBoxBrandBackgroundGrid2ItemNoLine} key={"Val" + f.ID} style={{ display: "flex", flexDirection: "column", gap: tokens.spacingHorizontalS, alignItems: "flex-end" }}>
                                                            <Body1Stronger>{f.quantity?.amount + " " + getUnitCodeString(f.quantity?.unitCode)}</Body1Stronger>
                                                            <Body1Stronger>{f.priceAmount?.amount.toLocaleString(undefined, { style: 'currency', currency: f.priceAmount.currency })}</Body1Stronger>
                                                            <Body1Stronger style={{ borderTop: 1, borderTopStyle: "solid", borderTopColor: tokens.colorNeutralForeground2 }}>{f.lineExtensionAmount?.amount.toLocaleString(undefined, { style: 'currency', currency: f.lineExtensionAmount.currency })}</Body1Stronger>
                                                        </div>
                                                    </>
                                                )}
                                            </div >
                                        </div>
                                    }
                                    {decodeDoc.additionalDocumentReferences.length > 0 &&
                                        <div className={styles.ContentBoxBrandBackground}>
                                            <Subtitle1>{t('AdditionalDocument')}</Subtitle1>
                                            <div className={styles.ContentBoxBrandBackgroundGrid} style={{ flexGrow: "1" }}>
                                                {decodeDoc.additionalDocumentReferences.map(f =>
                                                    <>
                                                        <Caption1 key={"Cap" + f.ID}>{f.documentDescription}</Caption1>
                                                        <div key={"Val" + f.ID} style={{ display: "flex", gap: tokens.spacingHorizontalS }}>
                                                            <Tooltip content={t('SaveDocument')} relationship="label">
                                                                <Button
                                                                    icon={<DownloadIcon />}
                                                                    shape="circular"
                                                                    size="small"
                                                                    aria-label="Download"
                                                                    disabled={!f.blob || !f.filename}
                                                                    onClick={() => {
                                                                        if (f.blob && f.filename) {
                                                                            saveAs(f.blob, f.filename);
                                                                        }
                                                                    }
                                                                    } />
                                                            </Tooltip>
                                                            <Tooltip content={t('ViewDocument')} relationship="label">
                                                                <Button
                                                                    icon={<ViewIcon />}
                                                                    shape="circular"
                                                                    size="small"
                                                                    aria-label="View"
                                                                    disabled={!f.blob}
                                                                    onClick={() => {
                                                                        if (f.blob) {
                                                                            if (filePreview !== f.blob) {
                                                                                setFilePreview(f.blob);
                                                                            }
                                                                            else {
                                                                                setFilePreview(undefined);
                                                                            }
                                                                        }
                                                                    }
                                                                    } />
                                                            </Tooltip>
                                                        </div>
                                                    </>
                                                )}
                                            </div >
                                        </div>
                                    }
                                </>
                            }
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            dispatch(dataActionCreators.editReceivedPeppolDoc(null));
                        }}
                    >
                        {t("Cancel")}
                    </Button>
                    <Button
                        onClick={() => submit()}
                        type="submit"
                        form="my-form-id"
                        appearance="primary"
                        disabled={!validChange}
                    >
                        {t("Save")}
                    </Button>
                </DialogActions>
            </DialogBody>
        </DialogSurface >
    </Dialog >;
};
